import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-cream warm-glow-light py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-244" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-245" data-mp="3b0kmrvce2uqr">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-246" data-mp="3azt57ofmmxjh">
          Testimonials from educators using this collection
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-247" data-mp="31zczs9fbpgbz">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-line bg-white p-6 text-ink shadow-card" data-id="element-248" data-mp="2x1l2ezvwt20e" data-mpi={index}>
              <div className="flex text-gold" aria-label="5 out of 5 stars" data-id="element-249" data-mp="h4n2y9bp5v9v">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-250" data-mp="780jnoz0rc9y" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-muted" data-id="element-251" data-mp="c7wpltra1ds5">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-4" data-id="element-252" data-mp="zxh86bjiq90w">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-forest text-sm font-extrabold text-white" data-id="element-253" data-mp="14vsj6pljupkp">
                  {initials}
                </span>
                <span data-id="element-254" data-mp="v57kz39sfn2b">
                  <b className="block text-sm text-ink" data-id="element-255" data-mp="v4epiyga4jzh">{name}</b>
                  <small className="text-xs text-muted" data-id="element-256" data-mp="1ivk131f6sq3z">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}